import './App.css';
import Sidebar from './Sidebar';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useCookies } from 'react-cookie';
import './Main.css';
import Background from './Background';
import { useState, useEffect } from 'react';
import { Link } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import { OPTIONAL_FIELDS, FIELD_LABELS } from './serviceFieldConfig';

const API_BASE = 'https://api.connecker.com/api';
const STORAGE_BASE = 'https://api.connecker.com/storage';

function Services() {

    const [cookies] = useCookies(['user']);
    const [serviceTypes, setServiceTypes] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [editingService, setEditingService] = useState(null);
    const [editForm, setEditForm] = useState({ name: '', image: null, allowed_fields: [] });

    const getServiceTypes = () => {
        setIsLoading(true);
        fetch(`${API_BASE}/get_service_types`, {
            method: 'POST'
        }).then(res => {
            setIsLoading(false);
            if (!res.ok) {
                throw Error('Could not fetch');
            }
            return res.json();
        }).then(data => {
            if (data.response_code === 200) {
                setServiceTypes(data.data || []);
            } else {
                setServiceTypes([]);
            }
        }).catch(() => {
            setIsLoading(false);
            setServiceTypes([]);
        });
    };

    const deleteServiceTypeAPI = (serviceTypeId) => {
        var data = new FormData();
        data.append("service_type_id", serviceTypeId);
        setIsLoading(true);
        fetch(`${API_BASE}/delete_service_type`, {
            method: 'POST',
            body: data,
            headers: {
                'Authorization': `Bearer ${cookies.token}`
            }
        }).then(res => res.json()).then(data => {
            setIsLoading(false);
            if (data.response_code === 200) {
                toast.success(data.message);
                getServiceTypes();
            } else {
                toast.error(data.message || 'Failed to delete service type');
            }
        }).catch(() => {
            setIsLoading(false);
            toast.error('Failed to delete service type');
        });
    };

    const deleteServiceType = (serviceTypeId) => {
        const result = window.confirm('Are you sure you want to delete this service type?');
        if (result) {
            deleteServiceTypeAPI(serviceTypeId);
        }
    };

    const openEditModal = (serviceType) => {
        setEditingService(serviceType);
        setEditForm({
            name: serviceType.name || '',
            image: null,
            allowed_fields: Array.isArray(serviceType.allowed_fields) ? [...serviceType.allowed_fields] : []
        });
    };

    const closeEditModal = () => {
        setEditingService(null);
        setEditForm({ name: '', image: null, allowed_fields: [] });
    };

    const toggleEditAllowedField = (field) => {
        setEditForm(prev => ({
            ...prev,
            allowed_fields: prev.allowed_fields.includes(field)
                ? prev.allowed_fields.filter(f => f !== field)
                : [...prev.allowed_fields, field]
        }));
    };

    const handleEditFormChange = (field, value) => {
        setEditForm(prev => ({ ...prev, [field]: value }));
    };

    const handleImageChange = (e) => {
        if (e.target.files && e.target.files[0]) {
            setEditForm(prev => ({ ...prev, image: e.target.files[0] }));
        }
    };

    const editServiceTypeAPI = (e) => {
        e.preventDefault();
        if (!editingService) return;
        var data = new FormData();
        data.append("service_type_id", String(editingService.id));
        data.append("name", editForm.name);
        if (editForm.image) {
            data.append("image", editForm.image);
        }
        editForm.allowed_fields.forEach(field => {
            data.append("allowed_fields[]", field);
        });
        setIsLoading(true);
        fetch(`${API_BASE}/update_service_type`, {
            method: 'POST',
            body: data,
            headers: {
                'Authorization': `Bearer ${cookies.token}`
            }
        }).then(res => res.json()).then(data => {
            setIsLoading(false);
            if (data.response_code === 200) {
                toast.success(data.message);
                closeEditModal();
                getServiceTypes();
            } else {
                toast.error(data.message || 'Failed to update service type');
            }
        }).catch(() => {
            setIsLoading(false);
            toast.error('Failed to update service type');
        });
    };

    const getImageUrl = (serviceType) => {
        if (serviceType.image) {
            return `${STORAGE_BASE}/${serviceType.image}`;
        }
        return '/images/Mask_Group_232.svg'; // fallback
    };

    useEffect(() => {
        getServiceTypes();
    }, []);

    return (
        <div className="content">
            <div className="row justify-content-start">
                <div className="col-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2">
                    <Sidebar></Sidebar>
                </div>
                <div className="col-10 col-sm-10 col-md-10 col-lg-10 col-xl-10 col-xxl-10" style={{ paddingLeft: '40px' }}>
                    <Background></Background>
                    <div className="d-flex justify-content-between align-items-center" style={{ marginTop: "50px" }}>
                        <h4 className="heading" style={{ color: "white" }}>Services</h4>
                        <Link to="/add_service_type">
                            <button
                                className="btn"
                                style={{
                                    backgroundColor: "#FF4500",
                                    color: "white",
                                    border: "1px solid #FF4500",
                                    borderRadius: "25px",
                                    padding: "10px 20px",
                                    fontWeight: "500"
                                }}
                            >
                                Add Service Type
                            </button>
                        </Link>
                    </div>

                    {isLoading && serviceTypes.length === 0 ? (
                        <p style={{ color: "white", marginTop: "20px" }}>Loading services...</p>
                    ) : (
                        <div className="row">
                            {serviceTypes.map((serviceType) => (
                                <div key={serviceType.id} className="col-md-4 col-lg-3 col-xl-3 col-xxl-3 col-sm-6 mb-3">
                                    <div className="card" style={{ width: "11rem", height: "11rem", marginTop: "1rem" }}>
                                        <div className="card-body d-flex flex-column justify-content-between" style={{ padding: "0.75rem" }}>
                                            <div className="text-center">
                                                <img
                                                    src={getImageUrl(serviceType)}
                                                    alt={serviceType.name}
                                                    style={{ width: "100px", height: "auto" }}
                                                />
                                                <h5 className="card-title subHeading" style={{ marginTop: "10px", marginBottom: 0 }}>{serviceType.name}</h5>
                                            </div>
                                            <div className="text-center mt-2">
                                                    <Link to={`/service_list/${serviceType.id}`}>
                                                        <button
                                                            className="btn btn-sm me-1"
                                                            style={{
                                                                backgroundColor: "#28a745",
                                                                borderColor: "#28a745",
                                                                color: "white",
                                                                fontSize: "11px",
                                                                padding: "4px 10px",
                                                                borderRadius: "6px"
                                                            }}
                                                        >
                                                            View
                                                        </button>
                                                    </Link>
                                                    <button
                                                        className="btn btn-sm me-1"
                                                        onClick={() => openEditModal(serviceType)}
                                                        style={{
                                                            backgroundColor: "#0d6efd",
                                                            borderColor: "#0d6efd",
                                                            color: "white",
                                                            fontSize: "11px",
                                                            padding: "4px 10px",
                                                            borderRadius: "6px"
                                                        }}
                                                    >
                                                        Edit
                                                    </button>
                                                    <button
                                                        className="btn btn-sm"
                                                        onClick={() => deleteServiceType(serviceType.id)}
                                                        style={{
                                                            backgroundColor: "#dc3545",
                                                            borderColor: "#dc3545",
                                                            color: "white",
                                                            fontSize: "11px",
                                                            padding: "4px 10px",
                                                            borderRadius: "6px"
                                                        }}
                                                    >
                                                        Delete
                                                    </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}

                    {!isLoading && serviceTypes.length === 0 && (
                        <p style={{ color: "white", marginTop: "20px" }}>No service types found. Add one to get started.</p>
                    )}
                </div>
            </div>

            {/* Edit Service Type Modal */}
            {editingService && (
                <div className="modal fade show d-block" style={{ backgroundColor: "rgba(0,0,0,0.5)" }} tabIndex="-1">
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Edit Service Type</h5>
                                <button type="button" className="btn-close" onClick={closeEditModal} aria-label="Close"></button>
                            </div>
                            <form onSubmit={editServiceTypeAPI}>
                                <div className="modal-body">
                                    <div className="mb-3">
                                        <label className="form-label">Name</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={editForm.name}
                                            onChange={(e) => handleEditFormChange('name', e.target.value)}
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label className="form-label">Allowed Fields</label>
                                        <p className="text-muted small mb-2">Select which extra fields to show when creating/viewing services of this type.</p>
                                        <div className="d-flex flex-wrap gap-2">
                                            {OPTIONAL_FIELDS.map(field => (
                                                <label key={field} className="d-inline-flex align-items-center gap-1 me-3 mb-1" style={{ cursor: 'pointer' }}>
                                                    <input
                                                        type="checkbox"
                                                        checked={editForm.allowed_fields.includes(field)}
                                                        onChange={() => toggleEditAllowedField(field)}
                                                    />
                                                    <span style={{ fontSize: "14px" }}>{FIELD_LABELS[field] || field}</span>
                                                </label>
                                            ))}
                                        </div>
                                    </div>
                                    <div className="mb-3">
                                        <label className="form-label">Image (optional - leave empty to keep current)</label>
                                        <input
                                            type="file"
                                            className="form-control"
                                            accept="image/*"
                                            onChange={handleImageChange}
                                        />
                                        {editForm.image ? (
                                            <div className="mt-2">
                                                <img
                                                    src={URL.createObjectURL(editForm.image)}
                                                    alt="Preview"
                                                    style={{ maxWidth: "200px", maxHeight: "150px", borderRadius: "8px" }}
                                                />
                                            </div>
                                        ) : editingService.image && (
                                            <div className="mt-2">
                                                <p className="text-muted small">Current image:</p>
                                                <img
                                                    src={`${STORAGE_BASE}/${editingService.image}`}
                                                    alt="Current"
                                                    style={{ maxWidth: "200px", maxHeight: "150px", borderRadius: "8px" }}
                                                />
                                            </div>
                                        )}
                                    </div>
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" onClick={closeEditModal}>Cancel</button>
                                    <button type="submit" className="btn btn-primary" disabled={isLoading}>
                                        {isLoading ? 'Saving...' : 'Save changes'}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            )}

            <ToastContainer />
        </div>
    );
}

export default Services;
